.containerRoot {
    height: auto;
    width: 14.0625rem;
    z-index: var(--mantine-priority-highest);
    color: white;
    border-bottom-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
    padding-bottom: 1rem;
}

.buttonLabel {
    align-items: baseline;
    padding-top: 5px;
}

.alertRoot {
    position: absolute;
    height: 2.5rem;
    width: 12rem;
    bottom: 50%;
    z-index: var(--mantine-priority-highest);
    border-radius: 1.5rem;
}

.overlay {
    border-bottom-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
}
